import React from 'react';
import nettestLogo from '../assets/nettestlogo.svg';

const Footer = () => {
  return (
    <footer>
      <div className="container footer-grid">
        <div className="f-col block-brand">
          <img src={nettestLogo} alt="NetTest Testere" style={{ height: '65px', width: 'auto', display: 'block', marginBottom: '1rem' }} />
          <p>Metal işleme dünyası için inovatif ve yüksek verimli kesme çözümlerinin güvenilir adresi.</p>
          <div className="social-links mt-2">
            <a href="#"><i className="fa-brands fa-linkedin-in"></i></a>
            <a href="#"><i className="fa-brands fa-instagram"></i></a>
            <a href="#"><i className="fa-brands fa-youtube"></i></a>
          </div>
        </div>
        <div className="f-col">
          <h4>Ürün Sınıflandırması</h4>
          <ul>
            <li><a href="#">Bimetal Şerit Testereler</a></li>
            <li><a href="#">Karbür Şerit Testereler</a></li>
            <li><a href="#">Elmas ve CBN Testereler</a></li>
            <li><a href="#">Karbon Şerit Testereler</a></li>
            <li><a href="#">Daire Testereler</a></li>
          </ul>
        </div>
        <div className="f-col">
          <h4>İletişim</h4>
          <ul>
            <li style={{ color: '#9ca3af', fontSize: '0.9rem', lineHeight: '1.6' }}>
              <i className="fa-solid fa-location-dot" style={{ color: 'var(--primary)', marginRight: '0.5rem' }}></i>
              Sultan Orhan Mahallesi 1185. Sokak No: 10 Gebze / Kocaeli
            </li>
            <li style={{ marginTop: '0.75rem' }}>
              <a href="https://wa.me/905470013478" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}><i className="fa-brands fa-whatsapp" style={{ color: '#25d366', fontSize: '1.2rem' }}></i>0547 001 34 78</a>
            </li>
            <li>
              <a href="tel:+905400013478"><i className="fa-solid fa-phone" style={{ marginRight: '0.5rem' }}></i>0540 001 34 78</a>
            </li>
            <li>
              <a href="mailto:info@nettesttestere.com"><i className="fa-regular fa-envelope" style={{ marginRight: '0.5rem' }}></i>info@nettesttestere.com</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container space-between align-center d-flex">
          <p>&copy; {new Date().getFullYear()} NetTest Testere. Tüm hakları saklıdır.</p>
          <div className="footer-legal">
            <a href="#">Gizlilik Politikası</a>
            <a href="#">KVKK Aydınlatma Metni</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
